import { window } from "global";
import { useEffect } from "react";
import { MediaQuery } from "@outplayed/responsive";
import { TierListHeader } from "../../TierListHeader";
import { TierListPageNav } from "../../TierListPageNav";
import { TierListFilterManager } from "../../TierListFilterManager";
import { ArenaTierListTable } from "./ArenaTierListTable";
import { TierListTablePlaceholder } from "../../common/TierListTablePlaceholder";
import { TierListTableError } from "../../common/TierListTableError";
import { useArenaTierList } from "@ugg/shared/api/requests/tier-lists/arena-tier-list";
import { RoleS } from "@ugg/shared/utils/role-helpers";
import { useQueryString } from "@ugg/shared/hooks/use-query-string";
import { SPECIAL_TIER_LIST_PAGES } from "@ugg/shared/pages/tier-list-pages";
import { useValidateQueryParams } from "@ugg/shared/query-params/params-helpers";
import { validParams } from "@ugg/shared/query-params/valid-params";
import { getArenaModeType } from "@ugg/shared/utils/queue-type-helpers";

type TierListContainerProps = {
  bannerSlot?: React.ReactNode;
  patchNotesCTA?: React.ReactNode;
};

export const ArenaTierListContainer = ({ bannerSlot, patchNotesCTA }: TierListContainerProps) => {
  const params = useQueryString();
  const { data, loading, error } = useArenaTierList({ params, ssr: true });
  const { win_rates, last_updated_at, total_matches } = data || {};

  const validateQueryParams = useValidateQueryParams(validParams);
  const validatedQueryParams = validateQueryParams(SPECIAL_TIER_LIST_PAGES.ARENA_TIER_LIST, params, true);
  const arenaModeType = getArenaModeType(validatedQueryParams.patch);

  useEffect(() => {
    window && window.scrollTo(0, 0);
  }, []);

  let table = null;
  if (!window) {
    table = null;
  } else if (loading) {
    table = <TierListTablePlaceholder />;
  } else if (error) {
    table = <TierListTableError />;
  } else {
    table = <ArenaTierListTable data={win_rates[RoleS.NONE] || []} arenaModeType={arenaModeType} />;
  }

  return (
    <div>
      <TierListHeader
        className="mb-[24px]"
        totalMatches={total_matches}
        lastUpdated={last_updated_at}
        loading={loading}
        includeMeta
        patchNotesCTA={patchNotesCTA}
      />
      <MediaQuery min="TABLET" max="DESKTOP_LARGE">
        <div>
          <TierListPageNav />
        </div>
      </MediaQuery>
      {bannerSlot}
      <TierListFilterManager className="my-[24px]" />
      {table}
    </div>
  );
};
